import React from 'react';
import Layout from '../components/Layout';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

function TermsPage() {
  var { t } = useTranslation();

  return (
    <Layout>
      <SEO title={PAGE_SEO['terms'].title} description={PAGE_SEO['terms'].description} url="/terms" />
      <div className="pt-32 pb-20 bg-black min-h-screen">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{t('termsTitle')}</h1>
          <p className="text-neutral-500 mb-12">{t('termsLastUpdated')}: January 2025</p>

          <div className="prose prose-invert prose-neutral max-w-none">
            <div className="space-y-8 text-neutral-300">
              <section>
                <h2 className="text-xl font-semibold text-white mb-3">1. {t('termsAcceptance')}</h2>
                <p>{t('termsAcceptanceText')}</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">2. {t('termsDescription')}</h2>
                <p>{t('termsDescriptionText')}</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">3. {t('termsAccounts')}</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>{t('termsAccountsAccurate')}</li>
                  <li>{t('termsAccountsSecurity')}</li>
                  <li>{t('termsAccountsAge')}</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">4. {t('termsUse')}</h2>
                <p>{t('termsUseAgree')}</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>{t('termsUseOwn')}</li>
                  <li>{t('termsUseFalse')}</li>
                  <li>{t('termsUseHarass')}</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">5. {t('termsPremium')}</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>{t('termsPremiumRequired')}</li>
                  <li>{t('termsPremiumRenew')}</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">6. {t('termsContact')}</h2>
                <p>
                  {t('termsContactText')}{' '}
                  <a href="mailto:trumpet95@hotmail.com" className="text-[#d4af37] hover:underline">
                    trumpet95@hotmail.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default TermsPage;
